"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var URL_1 = require("./URL");
Object.defineProperty(exports, "URL", { enumerable: true, get: function () { return URL_1.URL; } });
var URLSearchParams_1 = require("./URLSearchParams");
Object.defineProperty(exports, "URLSearchParams", { enumerable: true, get: function () { return URLSearchParams_1.URLSearchParams; } });
